import Vue from 'vue'
import vueCookie from 'vue-cookie'
import util from '@/utils'
Vue.use(vueCookie)
const vue = util.getInstance()

// https://www.npmjs.com/package/vue-cookie
// cookie默认保存30天
const defaultOption = {
	expires: 30,
	// domain: '.xx.com',
	path: '/'
}

const cookie = {
	get (key) {
		return vue.$cookie.get(key)
	},
	set (key, value, option = {}) {
		value = value || ''
		return vue.$cookie.set(key, value, Object.assign({}, defaultOption, option))
	},
	delete (key, option = {}) {
		// return cookie.set(key, '', {
		// 	expires: '-1D'
		// })
		return vue.$cookie.delete(key, option)
	}
}

export default cookie



// WEBPACK FOOTER //
// ./src/utils/cookie.js